import * as React from 'react';
import { useState } from 'react';

import { SlCheckbox } from '@shoelace-style/shoelace/dist/react';

import { SmallButton } from '~shared/components/buttons/SmallButton';

import { GenerateQuestionDialogContent } from '../Layout/GenerateQuestionDialogContent';

interface SelectQuestionsProps {
  onBack: () => void;
  questions: Array<{
    questionId: number;
    type: string;
    questionText: string;
  }>;
}

export function SelectQuestions({ onBack, questions }: SelectQuestionsProps) {
  const [selectedQuestions, setSelectedQuestions] = useState<Set<number>>(
    new Set()
  );

  const handleQuestionCheckedChanged = ({
    checked,
    questionId,
  }: {
    checked: boolean;
    questionId: number;
  }) => {
    const newSelectedQuestions = new Set([...selectedQuestions]);
    if (checked) {
      newSelectedQuestions.add(questionId);
    } else {
      newSelectedQuestions.delete(questionId);
    }
    setSelectedQuestions(newSelectedQuestions);
  };

  return (
    <GenerateQuestionDialogContent
      header={
        <GenerateQuestionDialogContent.Header onBack={onBack}>
          Select Areas of Improvement to include in the assessment.
        </GenerateQuestionDialogContent.Header>
      }
      footer={
        <GenerateQuestionDialogContent.Footer>
          <SmallButton onClick={() => {}}>Edit</SmallButton>
          <SmallButton onClick={() => {}}>Save</SmallButton>
        </GenerateQuestionDialogContent.Footer>
      }
    >
      <div className="flex flex-col gap-2">
        {questions.map(({ questionId, type, questionText }) => (
          <SlCheckbox
            key={questionId}
            role="checkbox"
            onSlChange={(evt) => {
              const checked = (evt.target as any).checked;
              handleQuestionCheckedChanged({ questionId, checked });
            }}
            checked={selectedQuestions.has(questionId)}
          >
            <strong>{type}</strong>
            <span>{questionText}</span>
          </SlCheckbox>
        ))}
      </div>
    </GenerateQuestionDialogContent>
  );
}
